// extracted by mini-css-extract-plugin
export default {"testimony":"styles_testimony__7p54G","overlay":"styles_overlay__QjPWN","icon":"styles_icon__m0EUs"};